export enum EnrolledTrainingTypes {
  ONLINE = 1,
  FACE = 2
}
